import { defineMessages } from "@/lib/i18n/messages";

export default defineMessages({
  es: { validationFallback: "Revisa los datos del formulario e intenta nuevamente." },
  en: { validationFallback: "Check the form details and try again." },
});
